import script from "./BookFallbackCover.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookFallbackCover.vue?vue&type=script&setup=true&lang=ts"

import "./BookFallbackCover.vue?vue&type=style&index=0&id=89bf101a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89bf101a"]])

export default __exports__